export const LOCALSTORAGES = {
  ACCESS_PLATFORM_ON: 'access-plataform-on',
};
